import { motion } from "framer-motion";
import { Zap, Snowflake, ArrowDownRight } from "lucide-react";

const line1 = ["Electrical", "&", "Air Con"];
const line2 = ["Specialists."];

const wordVariant = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.09, ease: [0.22, 1, 0.36, 1] },
  }),
};

const MaskLine = ({ words, offset = 0, accent }) => (
  <span className="block overflow-hidden">
    <span className="flex flex-wrap gap-x-[0.25em]">
      {words.map((w, i) => (
        <motion.span
          key={w + i}
          custom={offset + i}
          variants={wordVariant}
          initial="hidden"
          animate="visible"
          className={`inline-block ${accent && i === 0 ? "text-brand-blue" : ""}`}
        >
          {w}
        </motion.span>
      ))}
    </span>
  </span>
);

export const Hero = ({ imageUrl }) => {
  return (
    <section id="top" className="relative pt-32 lg:pt-40 pb-16 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-1.5 font-body text-xs font-medium tracking-wide text-ink/70">
            <Zap size={13} className="text-brand-yellow fill-brand-yellow" /> Electrical
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-1.5 font-body text-xs font-medium tracking-wide text-ink/70">
            <Snowflake size={13} className="text-brand-blue" /> Air Con
          </span>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <h1 className="font-display font-extrabold tracking-tighter leading-[0.92] text-ink text-[15vw] sm:text-7xl lg:text-8xl xl:text-[8.5rem]">
              <MaskLine words={line1} offset={0} />
              <MaskLine words={line2} offset={line1.length} accent />
            </h1>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.9 }}
            className="lg:col-span-4 lg:pb-4"
          >
            <p className="font-body text-lg text-ink/60 leading-relaxed max-w-sm">
              NAPIT approved and Gas Safe registered. Installation, maintenance and repairs across your home — done to a studio standard.
            </p>
            <p className="mt-5 font-display text-sm uppercase tracking-[0.25em] text-ink/40">
              Installation • Maintenance • Repairs
            </p>
            <a
              href="#aircon"
              data-testid="hero-cta-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-7 py-4 font-body text-sm font-semibold text-white hover:bg-brand-blue active:scale-95 transition-[background-color,transform] duration-200"
            >
              Build your air con quote <ArrowDownRight size={18} />
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-14 relative rounded-2xl overflow-hidden border border-black/10 aspect-[16/8]"
        >
          <img
            src={imageUrl}
            alt="Air conditioning installation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
          <div className="absolute bottom-6 left-6 flex items-center gap-6">
            <div>
              <p className="font-display text-4xl font-extrabold text-white tracking-tight">07881 746 762</p>
              <p className="font-body text-sm text-white/70 mt-1">Call us direct — free, no-obligation advice</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
